import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
            分类导航
          </h2>
          <Link
            to="/category/movie"
            className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-lg text-foreground-600 group-hover:text-primary-600`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 text-center leading-tight">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}